<mat-toolbar style="background-color: rgb(0,113,102);" role="heading">
  <!-- <span>{{ title }}</span> -->

  <span class="toolbar-spacer"></span>

  <img src="../../../assets/CTLogPlusblanco.png" width="100"/>
</mat-toolbar>


<p class="message-unauthorized">
  <mat-icon>error_outline</mat-icon>
  <br>
  Su sesión ha expirado, por favor vuelva a loguearse.
  <br>
  Si esta usando un link privado y estas logueado, no tiene permiso a dicha grabación.
</p>
